import _ from 'lodash';
import { useMemo } from 'react';
import { useFeatureParam } from '../../../../../../shared/frontend/scripts/selectors/global';
import { StatisticsDataType } from '../../../../../../shared/types/statisticsTypes';
import {
  DEFAULT_METRICS_VISIBILITY,
  StatisticMetricsMenuItemsGroup,
  STATISTICS_GROUPS_TO_DATA_TYPES_MAP
} from '../constants';

export const EXPORT_METRICS_VISIBILITY_PARAM_KEY = 'statistics_metrics_visibility';

export const useStatisticMetricsVisibility = () => {
  return useFeatureParam(EXPORT_METRICS_VISIBILITY_PARAM_KEY, parseMetricsVisibility);
};

export const parseMetricsVisibility = (value: string) => {
  let visibilityMap: Record<StatisticsDataType, boolean>;

  if (!value) {
    visibilityMap = DEFAULT_METRICS_VISIBILITY;
  } else {
    try {
      const parsedValue: Record<string, unknown> = JSON.parse(value);

      if (!_.isObject(parsedValue)) {
        visibilityMap = DEFAULT_METRICS_VISIBILITY;
      } else {
        visibilityMap = Object.entries(DEFAULT_METRICS_VISIBILITY).reduce(
          (acc, [key, defaultValue]) => {
            if (key in parsedValue) {
              acc[key as StatisticsDataType] = !!parsedValue[key];
            } else {
              acc[key as StatisticsDataType] = defaultValue;
            }
            return acc;
          },
          {} as Record<StatisticsDataType, boolean>
        );
      }
    } catch {
      visibilityMap = DEFAULT_METRICS_VISIBILITY;
    }
  }

  const groupVisibilityMap = useMemo(
    () =>
      Object.entries(STATISTICS_GROUPS_TO_DATA_TYPES_MAP).reduce(
        (acc, [group, dataTypes]) => {
          const isSomeMetricInGroupVisible = dataTypes.some((dataType) => visibilityMap[dataType]);
          acc[group as StatisticMetricsMenuItemsGroup] = isSomeMetricInGroupVisible;
          return acc;
        },
        {} as Record<StatisticMetricsMenuItemsGroup, boolean>
      ),
    [visibilityMap]
  );

  return {
    visibilityMap,
    groupVisibilityMap
  };
};
